import { useMemo } from 'react';
import { removeConnections } from 'shared/apollo';
import { gql } from 'apollo-boost';
import { useQuery as useQueryApollo } from 'react-apollo';
import { useQuery, useMutation } from 'shared/apollo';

const query = gql`
  query($section: String!, $investment: Int) {
    allNpoReportQuestions(
      filters: { section: $section, investment: $investment }
    ) {
      edges {
        node {
          dbId
          text
          questionType
          sectionStart
          nextQuestionId
          helpContent
          enumPrograms
          tab
          autoSave
          isProgramQuestion
          enumResponses {
            edges {
              node {
                dbId
                order
                responseType
                response
                responseValue
                responseHelp
                questionId
                nextQuestionId
              }
            }
          }
          validations {
            edges {
              node {
                dbId
                validation
                validationType
                text
              }
            }
          }
        }
      }
    }
  }
`;

export function useQuestionsBySection(section, investment) {
  const rawData = useQuery(query, { section, investment });
  const data = useMemo(
    () =>
      rawData?.allNpoReportQuestions?.edges.length > 0
        ? removeConnections(rawData?.allNpoReportQuestions)
        : [],
    [rawData],
  );
  if (data.length > 0) {
    data.forEach((_row, i) => {
      if (data[i]) {
        data[i].enumPrograms =
          rawData?.allNpoReportQuestions?.edges?.[i].node?.enumPrograms || [];
      }
    });
  }
  return { data };
}

export function useAllQuestions(reportId, userId) {
  const queryAll = gql`query {
    allNpoReportQuestions(filters: {report: ${reportId}, user: ${userId}}) {
      edges {
        node {
          dbId
          text
          questionType
          section
          sectionStart
          nextQuestionId
          helpContent
          autoSave
          tab
          isProgramQuestion
          enumResponses {
            edges {
              node {
                dbId
                order
                responseType
                response
                responseValue
                responseHelp
                questionId
                nextQuestionId
                treeGroup
              }
            }
          }
          validations {
            edges {
              node {
                dbId
                validation
                validationType
                text
              }
            }
          }
        }
      }
    }
  }
  `;
  const { data: rawData, refetch, loading } = useQueryApollo(
    queryAll /*, { fetchPolicy: "no-cache"}*/,
  );
  const data = useMemo(
    () => removeConnections(rawData?.allNpoReportQuestions),
    [rawData],
  );
  return { data, refetch, loading };
}

export const queryClear = gql`
  mutation clearQuestionAnswers($questionId: Int!, $investmentId: Int!) {
    clearQuestionAnswers(questionId: $questionId, investmentId: $investmentId) {
      success
    }
  }
`;

export const useClearQuestionAnswers = () => {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    try {
      mutate(queryClear, variables, () => {
        if (typeof onFinish === 'function') {
          onFinish();
        }
      });
    } catch (err) {
      console.error(err);
    }
  };
  return { data, isLoading, run };
};
